import common from "../common";
import Scene from "./Scene";
import Button from "../ui/Button";

export default class SplashScene extends Scene {
    constructor()
    {
        super('SplashScene');
    }

    init()
    {
        super.init('bg');

        var chars = [
            common.display.sprite({asset:'char_zatana', x:common.STAGE_HALF_WIDTH + 140, y:common.STAGE_HALF_HEIGHT + 100, anchor:0.5, parent:this}),
            common.display.sprite({asset:'char_bumble', x:common.STAGE_HALF_WIDTH - 300, y:common.STAGE_HALF_HEIGHT - 250, anchor:0.5, parent:this}),
            common.display.sprite({asset:'char_green', x:common.STAGE_HALF_WIDTH + 260, y:common.STAGE_HALF_HEIGHT - 190, anchor:0.5, parent:this}),
            common.display.sprite({asset:'char_bat', x:common.STAGE_HALF_WIDTH - 400, y:common.STAGE_HALF_HEIGHT + 70, anchor:0.5, parent:this}),
            common.display.sprite({asset:'char_super', x:common.STAGE_HALF_WIDTH - 200, y:common.STAGE_HALF_HEIGHT + 100, anchor:0.5, parent:this}),
            common.display.sprite({asset:'char_wonder', x:common.STAGE_HALF_WIDTH + 350, y:common.STAGE_HALF_HEIGHT + 100, anchor:0.5, parent:this})
        ];

        for(var i = 0; i < chars.length; i++)
        {
            chars[i].alpha = 0;
            chars[i].scale.set(0.4);
            
            TweenMax.to(chars[i], 0.5, {delay:1 + (i*0.2), alpha:1, x:chars[i].x, y:chars[i].y, ease:Expo.easeOut, onStart:() => {
                if(!common.audio.audioBlocked)
                {
                    common.audio.playSound(['sfx_powerup_arrive_00', 'sfx_powerup_arrive_01']);
                }
            }});
            TweenMax.to(chars[i].scale, 0.5, {delay:1 + (i*0.2), x:1, y:1, ease:Expo.easeOut});
        
            if(chars[i].y < common.STAGE_HALF_HEIGHT)
            {
                TweenMax.to(chars[i].anchor, 0.6 + (Math.random()*0.5), {delay:Math.random(), y:i%2==0 ? 0.55 : 0.45, yoyo:true, repeat:-1, ease:Sine.easeInOut});
            }

            chars[i].x = common.STAGE_HALF_WIDTH;
            chars[i].y = common.STAGE_HALF_HEIGHT;
        }

        var gameLogo = common.display.sprite({asset:'logo_game', x:common.STAGE_HALF_WIDTH, y:300, scale:1.4, alpha:0, anchor:0.5, parent:this});
        TweenMax.to(gameLogo.scale, 0.8, {delay:1.5, x:1, y:1, ease:Elastic.easeOut, onComplete:() => {
            this.buttons.play.appear();
        }});
        TweenMax.to(gameLogo, 0.2, {delay:1.5, alpha:1, ease:Expo.easeOut});
        
        common.display.sprite({asset:'logo_ip', x:common.STAGE_HALF_WIDTH, y:100, anchor:0.5, parent:this});
        common.display.sprite({asset:'logo_dc', x:common.STAGE_HALF_WIDTH - 370, y:common.STAGE_HEIGHT - 40, anchorX:0.5, anchorY:1, parent:this});
        common.display.sprite({asset:'logo_cn', x:common.STAGE_HALF_WIDTH - 270, y:common.STAGE_HEIGHT - 40, anchorX:0.5, anchorY:1, parent:this});

        this.buttons.play = new Button(new P3.ButtonStates(
            P3.assets.texture('btn_primary_large_out'),
            P3.assets.texture('btn_primary_large_over'),
            P3.assets.texture('btn_primary_large_down'),
            P3.assets.texture('icon_play')
        ));
        this.buttons.play.id = 'play';
        this.buttons.play.icon.anchor.set(0.45, 0.53);
        this.buttons.play.x = common.STAGE_HALF_WIDTH;
        this.buttons.play.y = common.STAGE_HEIGHT - 200;
        this.buttons.play.hide();
        this.signalListeners.push(this.buttons.play.signals.click.add(this.onButtonClicked, this));
        this.addChild(this.buttons.play);

        if(!common.audio.audioBlocked)
        {
            common.audio.playSound('music_splash_loop', this.audioLoopParams);
        }
    }

    destroy()
    {
        super.destroy();
    }

    update()
    {
        super.update();
    }

    resize()
    {
        super.resize();
    }

    onButtonClicked(button)
    {
        if(button.id == 'play')
        {
            common.audio.stopSound('music_splash_loop');
            common.audio.playSound('music_splash_press_play_sting');
            this.signals.next.dispatch();
        }
    }
}